import React, { useEffect, useState, useRef } from "react";
import _ from "lodash";
import { FormControl, Grid, InputLabel, Box } from "@material-ui/core";
import {
  Paper,
  Heading,
  PrimaryButton,
  Dropdown,
  Input,
  WorkflowNameInput,
  Button,
} from "../../components";

import { workflowStatuses } from "../../utils/constants";
import { useQueryState } from "react-router-use-location-state";
import SearchTabs from "./SearchTabs";
import ResultsTable from "./ResultsTable";
import DateRangePicker from "../../components/DateRangePicker";
import { DEFAULT_ROWS_PER_PAGE } from "../../components/DataTable";
import { useWorkflowSearch } from "../../data/workflow";

import { makeStyles } from "@material-ui/styles";
import clsx from "clsx";
import executionsStyles from "./executionsStyles";
import sharedStyles from "../styles";
import { FilterList } from "@material-ui/icons";

//////////////
import {
  NavLink,
  DataTable,
  LinearProgress,
  TertiaryButton,
  Text,
} from "../../components";
import { Alert, AlertTitle } from "@material-ui/lab";
// import { makeStyles } from "@material-ui/styles";
import BulkActionModule from "./BulkActionModule";
// import executionsStyles from "./executionsStyles";
import { dataTableStyles } from "../styles";
import { Tooltip } from "@material-ui/core";
import moment from "moment";
import { colors } from "../../theme/variables";
// import _ from "lodash";
var executionFields = [
  {
    name: "startTime",
    grow: 0.5,
    wrap: false,
    type: "date",
    label: (
      <Tooltip title="Start Time">
        <div>Start Time</div>
      </Tooltip>
    ),
    renderer: (val) => (
      <Tooltip title={val ? moment(val).format('DD-MM-YYYY HH:mm:ss') : ''}>
        <div>{val ? moment(val).format('DD-MM-YYYY HH:mm:ss') : ''}</div>
      </Tooltip>
    ),
  },
  {
    name: "category",
    sortable: false,
    grow: 0.5,
    wrap: false,
    label: (
      <Tooltip title="Type">
        <div>Type</div>
      </Tooltip>
    ),
    renderer: (val) => (
      <Tooltip title={val}>
        <div>{val}</div>
      </Tooltip>
    ),
  },
  {
    name: "requestId",
    sortable: false,
    grow: 0.5,
    wrap: false,
    label: (
      <Tooltip title="Request ID">
        <div>Request ID</div>
      </Tooltip>
    ),
    renderer: (val) => (
      val ? <Tooltip title={val || ""}>
        <div>{val}</div>
      </Tooltip> : <div>{val}</div>
    ),
  },
  {
    name: "workflowId",

    grow: 0.5,
    wrap: false,
    label: (
      <Tooltip title="Workflow ID">
        <div>Workflow ID</div>
      </Tooltip>
    ),
    renderer: (workflowId) => (
      <Tooltip title={workflowId}>
        <NavLink path={`/execution/${workflowId}`}>{workflowId}</NavLink>
      </Tooltip>
    ),
  },
  {
    name: "workflowType",
    grow: 0.5,
    width: '200px',
    wrap: false,
    label: (
      <Tooltip title="Workflow Name">
        <div>Workflow Name</div>
      </Tooltip>
    ),
    renderer: (val) => (
      <Tooltip title={val}>
        <div>{val}</div>
      </Tooltip>
    ),
  },
  {
    name: "version",
    sortable: false,
    grow: 0.5,
    label: (
      <Tooltip title="Version">
        <div>Version</div>
      </Tooltip>
    ),
  },
  {
    name: "correlationId",
    sortable: false,
    grow: 0.5,
    label: (
      <Tooltip title="Correlation ID">
        <div>Correlation ID</div>
      </Tooltip>
    ),
    renderer: (val) => (
     val ?  <Tooltip title={val || ""}>
        <div>{val}</div>
      </Tooltip> : <div>{val}</div>
    ),
  },
  {
    name: "updateTime",
    type: "date",

    grow: 0.5,
    wrap: false,
    label: (
      <Tooltip title="Update Time">
        <div>Update Time</div>
      </Tooltip>
    ),
    renderer: (val) => (
      <Tooltip title={val ? moment(val).format('DD-MM-YYYY HH:mm:ss') : ''}>
        <div>{val ? moment(val).format('DD-MM-YYYY HH:mm:ss') : ''}</div>
      </Tooltip>
    ),
  },
  {
    name: "endTime",
    type: "date",
    grow: 0.5,
    wrap: false,
    label: (
      <Tooltip title="End Time">
        <div>End Time</div>
      </Tooltip>
    ),
    renderer: (val) => (
      <Tooltip title={val ? moment(val).format('DD-MM-YYYY HH:mm:ss') : ''}>
        <div>{val ? moment(val).format('DD-MM-YYYY HH:mm:ss') : ''}</div>
      </Tooltip>
    ),
  },
  {
    name: "status",

    grow: 0.5,
    wrap: false,
    label: (
      <Tooltip title="Status">
        <div>Status</div>
      </Tooltip>
    ),
  },
  {
    name: "input",
    grow: 0.5,
    width: '200px',
    sortable: false,
    wrap: false,
    label: (
      <Tooltip title="Input">
        <div>Input</div>
      </Tooltip>
    ),
    type: "json",

    renderer: (val) => {
      return (
        <Tooltip title={JSON.stringify(val)}>
          <div>{JSON.stringify(val)}</div>
        </Tooltip>
      );
    },
  },
  {
    name: "output",
    type: "json",
    sortable: false,
    width: '200px',

    grow: 2,
    wrap: false,
    label: (
      <Tooltip title="Output">
        <div>Output</div>
      </Tooltip>
    ),
    renderer: (val) => {
      return (
        <Tooltip title={val}>
          <div>{val}</div>
        </Tooltip>
      );
    },
  },
  {
    name: "reasonForIncompletion",
    width: '200px',
    grow: 0.5,
    wrap: false,
    label: (
      <Tooltip title="Reason For Incompletion">
        <div>Reason For Incompletion</div>
      </Tooltip>
    ),
    renderer: (val) => (
      <Tooltip title={val}>
        <div>{val}</div>
      </Tooltip>
    ),
  },
  {
    name: "executionTime",
    width: '200px',
    label: (
      <Tooltip title="Execution Time">
        <div>Execution Time</div>
      </Tooltip>
    ),
  },
  {
    name: "event",
    sortable: false,

    wrap: false,
    label: (
      <Tooltip title="Event">
        <div>Event</div>
      </Tooltip>
    ),
  },
  {
    name: "failedReferenceTaskNames",
    grow: 0.5,
    sortable: false,

    wrap: false,
    label: (
      <Tooltip title="Failed Reference Task Names">
        <div>Failed Reference Task Names</div>
      </Tooltip>
    ),
    renderer: (val) => (
      <Tooltip title={val}>
        <div>{val}</div>
      </Tooltip>
    ),
  },
  {
    name: "externalInputPayloadStoragePath",
    sortable: false,

    grow: 1,
    wrap: false,
    label: (
      <Tooltip title="External Input Payload Storage Path">
        <div>External Input Payload Storage Path</div>
      </Tooltip>
    ),
  },
  {
    name: "externalOutputPayloadStoragePath",
    sortable: false,

    grow: 1,
    wrap: false,
    label: (
      <Tooltip title="External Output Payload Storage Path">
        <div>External Output Payload Storage Path</div>
      </Tooltip>
    ),
  },
  {
    name: "priority",
    sortable: false,

    grow: 0.5,
    wrap: false,
    label: (
      <Tooltip title="Priority">
        <div>Priority</div>
      </Tooltip>
    ),
  },
];

var defaultShowColumns = [
  "startTime",
  "requestId",
  "workflowType",
  "workflowId",
  "endTime",
  "status",
]

function ShowMore({
  rowsPerPage,
  rowCount,
  onChangePage,
  onChangeRowsPerPage,
  currentPage,
}) {
  return (
    <div style={{ textAlign: "center", padding: 15 }}>
      <TertiaryButton onClick={() => onChangePage(currentPage + 1)}>
        Show More Results
      </TertiaryButton>
    </div>
  );
}

///////////////////

const useStyles = makeStyles({
  ...executionsStyles,
  ...sharedStyles,

  inputWrapper: {
    display: "flex",
    flexDirection: "column",
  },
  inputLabel: {
    marginBottom: 1,
    marginLeft: 2,
    fontSize: 10,
    fontWeight: 600,
    color: "#000",
  },
  subheader: {
    minHeight: "150px",
    alignItems: "center",
    justifyContent: "space-evenly",
    display: 'flex',
    width: '100%',
    flexWrap: 'wrap',
    backgroundColor:'#f4f6ff'
  },
});

const DEFAULT_SORT = "startTime:DESC";
const MS_IN_DAY = 86400000;

export default function WorkflowPanel(props) {
  const permissions = props?.permissions;
  const classes = useStyles();

  const [freeText, setFreeText] = useQueryState("freeText", "");
  const [status, setStatus] = useQueryState("status", []);
  const [workflowType, setWorkflowType] = useQueryState("workflowType", []);
  const [workflowId, setWorkflowId] = useQueryState("workflowId", "");
  const [startFrom, setStartFrom] = useQueryState("startFrom", "");
  const [startTo, setStartTo] = useQueryState("startTo", "");
  const [lookback, setLookback] = useQueryState("lookback", "");
  const [requestId, setRequestid] = useQueryState('requestId', '');

  const [page, setPage] = useQueryState("page", 1);
  const [rowsPerPage, setRowsPerPage] = useQueryState(
    "rowsPerPage",
    DEFAULT_ROWS_PER_PAGE
  );
  const [sort, setSort] = useQueryState("sort", DEFAULT_SORT);
  const [queryFT, setQueryFT] = useState(buildQuery);
  const [filterClicked, setFilterClicked] = useState(false);

  const { data: resultObj, error, isFetching, refetch } = useWorkflowSearch({
    page,
    rowsPerPage,
    sort,
    query: queryFT.query,
    freeText: queryFT.freeText, 
  });

  function buildQuery() {
    const clauses = [];
    if (!_.isEmpty(workflowType)) {
      clauses.push(`workflowType IN (${workflowType.join(",").toLowerCase()})`);
    }
    if (!_.isEmpty(workflowId)) {
      clauses.push(`workflowId="${workflowId}"`);
    }
    if (!_.isEmpty(status)) {
      clauses.push(`status IN (${status.join(",").toLowerCase()})`);
    }
    if (!_.isEmpty(lookback)) {
      clauses.push(`startTime>${new Date().getTime() - lookback * MS_IN_DAY}`);
    }
    if (!_.isEmpty(startFrom)) {
      clauses.push(`startTime>${new Date(startFrom).getTime()}`);
    }
    if (!_.isEmpty(startTo)) {
      clauses.push(`startTime<${new Date(startTo).getTime()}`);
    }
    if (!_.isEmpty(requestId)) {
      clauses.push(`requestId="${requestId}"`);
    }

    return {
      query: clauses.join(" AND "),
      freeText: _.isEmpty(freeText) ? "*" : freeText,
    };
  }

  function doSearch() {
    setPage(1);
    const oldQueryFT = queryFT;
    const newQueryFT = buildQuery();
    setQueryFT(newQueryFT);

    // Only force refetch if query didn't change. Else let react-query detect difference and refetch automatically
    if (_.isEqual(oldQueryFT, newQueryFT)) {
      refetch();
    }
  }
  const resetSearch = () => {
    setWorkflowType([])
    setWorkflowId('')
    setStatus([])

    setStartFrom('')
    setStartTo('')
    setLookback('')
    setFreeText('')
    setRequestid('')

    setShowSubHeader(false)
  };
  const handleLookback = (val) => {
    setStartFrom("");
    setStartTo("");
    setLookback(val);
  };

  const handleStartFrom = (val) => {
    setLookback("");
    setStartFrom(val);
  };

  const handleStartTo = (val) => {
    setLookback("");
    setStartTo(val);
  };

  // dataTable
  let totalHits = 0;
  if (resultObj) {
    if (resultObj.totalHits) {
      totalHits = resultObj.totalHits;
    } else {
      if (resultObj.results) {
        totalHits = resultObj.results.length;
      }
    }
  }
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [showSubHeader, setShowSubHeader] = useState(false);
  const tableRef = useRef(null);

  const defaultSortField = sort ? sort.split(":")[0] : null;
  const defaultSortDirection = sort ? sort.split(":")[1] : null;

  const handleExecutionFilterClick = (e) => {
    e.stopPropagation();
    setShowSubHeader(!showSubHeader);
  };

  useEffect(() => {
    setSelectedRows([]);
    setToggleCleared((t) => !t);
  }, [resultObj]);

  useEffect(() => {
    if (workflowType.length) setShowSubHeader(true);
  }, [workflowType]);
  // dataTable

  return (
    <div className={clsx([classes.wrapper])}>
      <Paper className={clsx([classes.paper], [classes.contentContainer])}>
        {permissions?.workflows?.active === "True" && permissions?.workflows.hide=== "False" && <SearchTabs tabIndex={0} permissions={permissions} />}
        {isFetching && <LinearProgress />}
        {error && (
          <Alert severity="error">
            <AlertTitle>Query Failed</AlertTitle>
            {error.message}
          </Alert>
        )}
        {!resultObj && !error && (
          <Text className={classes.clickSearch}>
            Click "Search" to submit query.
          </Text>
        )}
        {resultObj && (
          <DataTable
            title={totalHits > 0 && ` Page ${page} of ${totalHits}`}
            data={resultObj.results}
            showRefresh={true}
            handleRefreshClick={() => {
              refetch();
            }}
            columns={executionFields}
            // columns={executionFields.filter((f) => defaultShowColumns.includes(f.name))}
            defaultShowColumns={defaultShowColumns}
            localStorageKey="executionsTable"
            keyField="workflowId"
            executionFilter
            handleExecutionFilterClick={handleExecutionFilterClick}
            paginationServer
            paginationTotalRows={totalHits}
            paginationDefaultPage={page}
            paginationPerPage={rowsPerPage}
            onChangeRowsPerPage={(rowsPerPage) => setRowsPerPage(rowsPerPage)}
            onChangePage={(page) => setPage(page)}
            sortServer
            defaultSortField={defaultSortField}
            defaultSortAsc={defaultSortDirection === "ASC"}
            onSort={(column, sortDirection) => {
              let sortName = column.id;
              if (["workflowId", "status", "workflowType", "event", "reasonForIncompletion"].includes(column.id)) {
                sortName = column.id + ".keyword";
              }
              setSort(sortName + ":" + sortDirection.toUpperCase(), sortDirection);
            }}
            selectableRows
            subHeader={showSubHeader}
            subHeaderComponent={
              <div className={classes.subheader}>
                <Grid container spacing={2} className={`${classes.controls}`}>
                  <Grid item xs={4}>
                    <div className={classes.inputWrapper}>
                      <WorkflowNameInput
                        fullWidth
                        placeholder="Workflow Name"
                        onChange={(evt, val) => setWorkflowType(val)}
                        value={workflowType}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={2}>
                    <div className={classes.inputWrapper}>
                      <Input
                        label="Workflow ID"
                        value={workflowId}
                        placeholder="Workflow ID"
                        onChange={setWorkflowId}
                        clearable
                      />
                    </div>
                  </Grid>
                  <Grid item xs={2}>
                    <div className={classes.inputWrapper}>
                      <Dropdown
                        label="Status"
                        placeholder="Status"
                        options={workflowStatuses}
                        multiple
                        onChange={(evt, val) => setStatus(val)}
                        value={status}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={4}>
                    <DateRangePicker
                      disabled={!_.isEmpty(lookback)}
                      from={startFrom}
                      to={startTo}
                      onFromChange={handleStartFrom}
                      onToChange={handleStartTo}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <div className={classes.inputWrapper}>
                      <Input
                        className={classes.lookback}
                        label="Lookback (days)"
                        placeholder="Lookback (days)"
                        value={lookback}
                        onChange={handleLookback}
                        type="number"
                        clearable
                        disabled={!_.isEmpty(startFrom) || !_.isEmpty(startTo)}
                      />
                    </div>
                  </Grid>

                  <Grid item xs={3}>
                    <div className={classes.inputWrapper}>
                      <Input
                        className={classes.lucene}
                        label="Lucene-syntax Query:"
                        placeholder="Lucene-syntax Query (Double-quote strings for Free Text Search)"
                        value={freeText}
                        onChange={setFreeText}
                        clearable
                      />
                    </div>
                  </Grid>
                  <Grid item xs={3}>
                    <div className={classes.inputWrapper}>
                      <Input
                        label="Request ID"
                        placeholder="Request ID"
                        value={requestId}
                        onChange={setRequestid}
                        clearable
                      />
                    </div>
                  </Grid>
                  <Grid
                    item
                    xs={0}
                    style={{
                      alignItems: "center",
                    }}>
                    <FormControl>
                      <PrimaryButton
                        className={classes.btnSearch}
                        onClick={doSearch}>
                        Search
                      </PrimaryButton>
                    </FormControl>
                  </Grid>
                  <Grid
                    item
                    xs={0}
                    style={{
                      alignItems: "center",
                    }}>
                    <FormControl>
                     <Button 
                     color='outlinedPrimary'
                        onClick={resetSearch}>
                        Cancel
                      </Button>
                    </FormControl>
                  </Grid>
                </Grid>
              </div>
            }
            contextComponent={
              <BulkActionModule
                selectedRows={selectedRows}
                popperAnchorEl={tableRef.current}
              />
            }
            onSelectedRowsChange={({ selectedRows }) =>
              setSelectedRows(selectedRows)
            }
            clearSelectedRows={toggleCleared}
            customStyles={{
              ...dataTableStyles,
              head: {
                style: {
                  overflow: "visible",
                  ...dataTableStyles.head,
                },
              },
              header: {
                style: {
                  overflow: "visible",
                  ...dataTableStyles.header,
                },
              },
              contextMenu: {
                style: {
                  display: "none",
                },
                activeStyle: {
                  display: "flex",
                },
              },
            }}
            // paginationComponent={showMore ? ShowMore : null}
            fixedHeader
            fixedHeaderScrollHeight={
              !showSubHeader ? "calc(-14.25rem + 100vh)" : "calc( 100vh - 24.5rem )"
            }
          />
        )}
      </Paper>
    </div>
  );
}
